import { useForm } from "@core/features/form";
import { useLogin, useGoogleLogin } from "@core/features/auth";
import { usePlatformStore } from "@platform/store";
import { useSignupDisabled } from "@platform/hooks/useSignupDisabled";
import { LoginForm } from "./LoginForm";

type Props = {
  onError?: () => void;
  onSuccess?: (data: any) => void;
};

export function LoginFormContainer({ onError, onSuccess }: Props) {
  const clearAuth = usePlatformStore((s) => s.clearAuth);
  const isSignupDisabled = useSignupDisabled();

  const handleError = () => {
    clearAuth();
    onError?.();
  };

  const { loginMutation, schema, defaultValues } = useLogin({
    onSuccess,
    onError: handleError,
  });

  const { form, handleSubmit } = useForm({
    schema,
    onSubmit: loginMutation.mutateAsync,
    defaultValues,
  });

  const googleLoginMutation = useGoogleLogin({
    form,
    onSuccess,
    onError: handleError,
  });

  return (
    <LoginForm
      form={form}
      onLogin={handleSubmit}
      onLoginWithGoogle={googleLoginMutation.mutateAsync}
      hideSignupLink={false}
    />
  );
}

export default LoginFormContainer;
